/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import CustomRSDropdown from '../../custom-rs-dropdown';
import styles from './styles.css';
import AddEditTemplateModal from '../add-edit-template-modal';

const { api } = require('../../../../lib/bputils').default;

class ReplyTemplateSelector extends React.Component {
  static propTypes = {
    onChange: PropTypes.func,
    enableTemplateEditor: PropTypes.bool.isRequired,
  }

  static defaultProps = {
    onChange: () => { },
  };

  constructor(props) {
    super(props);

    this.state = {
      options: null,
      // When user is adding/editing the template via Modal. As soon as user clicks on Modal, the template selector
      // dropdown closes and the modal being child of the dropdown the modal also closes because user clicked outside dropdown
      // So user cannot ever type anything in the modal. So following flag will tell the dropdown to keep it open when
      // add/edit modal is open. Once the Modal is closed, behave normally i.e. close when user click outside the dropdown
      keepReplyTemplateDropdownOpen: false,
    };
  }

  initComponent = async () => {
    const { enableTemplateEditor } = this.props;
    const { categories, templates } = await this.getCategoriesAndReplyTemplates();
    this.setState(() => ({ options: [] }));

    const sortedTemplates = _.sortBy(templates, ['category', 'title']);

    let options = [
      {
        label: 'Suggested Reply Templates',
        value: 'suggestedTemplates',
        isGroup: true,
      },
      // Inject Suggested Reply templates
      ...sortedTemplates.filter(t => t.id <= 0).map(t => ({
        label: `${t.category} - ${t.title}`,
        displayValue: `${t.category} - ${t.title}`,
        value: String(t.id),
      })),
    ];

    if (enableTemplateEditor) {
      options = options.concat([{
        label: 'My Reply Templates',
        value: 'myTemplates',
        isGroup: true,
      },
      // Inject My Reply templates
      ...sortedTemplates.filter(t => t.id > 0).map(t => ({
        label: (
          <>
            <div className={styles.templateName} data-value={String(t.id)}>
              {/* Above DIV conflicts with DropDown Item Click event. So setting the data-value here as wells */}
              {`${t.category} - ${t.title}`}
            </div>
            <AddEditTemplateModal
              categories={categories}
              template={t}
              onTemplateChanged={this.handleOnTemplateChanged}
              onModalOpen={this.handleOnModalOpen}
              onModalClose={this.handleOnModalClose}
            />
          </>
        ),
        displayValue: `${t.category} - ${t.title}`,
        value: String(t.id),
      })), {
        label: (
          <>
            <AddEditTemplateModal
              categories={categories}
              onTemplateChanged={this.handleOnTemplateChanged}
              onModalOpen={this.handleOnModalOpen}
              onModalClose={this.handleOnModalClose}
            />
          </>
        ),
        value: 'newTemplate',
        isGroup: true,
      }]);
    }

    this.setState(() => ({ options, templates }));
  }

  getCategoriesAndReplyTemplates = async () => {
    const getCategoriesTask = api.get({
      path: '/reviews/replies/templates/categories',
      requestId: 'getReplyTemplateCategories',
    });

    const getReplyTemplatesTask = api.get({
      path: '/reviews/replies/templates',
      requestId: 'getReviewReplyTemplates',
    });

    const [categories, templates] = await Promise.all([getCategoriesTask, getReplyTemplatesTask]);
    return { categories, templates };
  };

  handleOnChangeTemplateDropdown = (selectedItem) => {
    const { templates } = this.state;
    const selectedTemplate = templates.find(t => t.id === Number(selectedItem.value));
    this.props.onChange(selectedTemplate);
  };

  handleOnModalOpen = () => {
    this.setState(() => ({ keepReplyTemplateDropdownOpen: true }));
  }

  handleOnModalClose = () => {
    this.setState(() => ({ keepReplyTemplateDropdownOpen: false }));
  }

  handleOnTemplateChanged = async () => {
    await this.initComponent();
  }

  componentDidMount = async () => {
    await this.initComponent();
  }

  render() {
    const { options, keepReplyTemplateDropdownOpen } = this.state;

    return (
      <CustomRSDropdown
        className={styles.replyTemplateDropdown}
        options={options || []}
        onChange={this.handleOnChangeTemplateDropdown}
        placeholder="Select a reply template"
        keepOpen={keepReplyTemplateDropdownOpen}
      />
    );
  }
}

export default ReplyTemplateSelector;
